import { render, staticRenderFns } from "./Cropper.vue?vue&type=template&id=5f45d696&scoped=true"
import script from "./Cropper.vue?vue&type=script&lang=js"
export * from "./Cropper.vue?vue&type=script&lang=js"
import style0 from "./Cropper.vue?vue&type=style&index=0&id=5f45d696&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f45d696",
  null
  
)

export default component.exports